import { createSlice } from "@reduxjs/toolkit";

export const contratSlice = createSlice({ //reducers for both hours in global state
    name: 'contrat',
    initialState:{},
    reducers: {
        setContrat: (currentState, action) => {
            return action.payload
        }
    }
});